function Header() {
    return (
        <>
            <header>
                <div className="wrapper">
                    <div className="heading-text-container">
                        <h1>Out of Context</h1>
                        <h2>Movie Spoiler</h2>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header;